import { render, staticRenderFns } from "./HomeMethodology.vue?vue&type=template&id=1841abce&scoped=true&"
import script from "./HomeMethodology.vue?vue&type=script&lang=js&"
export * from "./HomeMethodology.vue?vue&type=script&lang=js&"
import style0 from "./HomeMethodology.vue?vue&type=style&index=0&id=1841abce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1841abce",
  null
  
)

export default component.exports